export default __webpack_public_path__ + "99ea3a0ae63604932eb470064cec1751.svg";